"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withOidcSecure = exports.OidcSecure = void 0;
var react_1 = __importStar(require("react"));
var oidc_1 = __importDefault(require("./vanilla/oidc"));
var OidcSecure = function (_a) {
    var children = _a.children, _b = _a.callbackPath, callbackPath = _b === void 0 ? null : _b, _c = _a.extras, extras = _c === void 0 ? null : _c, _d = _a.configurationName, configurationName = _d === void 0 ? "default" : _d, _e = _a.state, state = _e === void 0 ? undefined : _e;
    var getOidc = oidc_1.default.get;
    var oidc = getOidc(configurationName);
    (0, react_1.useEffect)(function () {
        if (!oidc.tokens) {
            oidc.loginAsync(callbackPath, extras, true, state);
        }
        return function () {
        };
    }, [configurationName, callbackPath, extras]);
    if (!oidc.tokens) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.OidcSecure = OidcSecure;
var withOidcSecure = function (WrappedComponent, callbackPath, extras, configurationName, state) {
    if (callbackPath === void 0) { callbackPath = null; }
    if (extras === void 0) { extras = null; }
    if (configurationName === void 0) { configurationName = "default"; }
    if (state === void 0) { state = undefined; }
    return function (props) {
        return react_1.default.createElement(exports.OidcSecure, { state: state, callbackPath: callbackPath, extras: extras, configurationName: configurationName },
            react_1.default.createElement(WrappedComponent, __assign({}, props)));
    };
};
exports.withOidcSecure = withOidcSecure;
//# sourceMappingURL=OidcSecure.js.map